/* V152 GOB SMOOTH (2026-10-19) — edits in this file, all marked "V152":
   · add-on reconcile delegates to GOBSmooth.syncAddons() (one queue, see gob-smooth.js)
   · the two 1 s countdown timers only tick while the drawer is open
   · no 400 ms scroll-lock watchdog interval (events + observers already cover it)
   · no layout read on every click anywhere on the page
   · discount-label observer no longer wakes on every countdown character
   · remove: one redraw, not two */
/* ============================================================
   GOB — cart drawer behaviour
   Extracted 2026-08-25 from snippets/header-cart-drawer.liquid.

   These fourteen blocks used to sit inline in the snippet, which meant
   ~66 KB of JavaScript was re-downloaded, re-parsed and re-executed on
   every single page view, on the main thread, and could never be cached.
   As a file it is fetched once and reused for the rest of the session.

   Nothing here has been rewritten. The blocks are concatenated in their
   original document order, at top level, so global scope is identical to
   before — block 1 still declares setCookie/getTimeLeft/formatTime/interval
   as globals exactly as it did inline. The only behavioural difference is
   that Liquid no longer strips the money-format placeholder out of two
   last-resort fallback strings, which makes them correct rather than
   truncated to a bare currency symbol.

   Loaded with defer from the snippet. Every block either waits for
   DOMContentLoaded already or only touches nodes rendered above it, so
   running after parse is equal or safer. No block uses document.write or
   document.currentScript.
   ============================================================ */


/* ---------- block 0 (was inline #0) ---------- */
    (function() {
      var MEMBERSHIP_PRODUCT_ID = 10601114403149;

      /* 2026-08-31 — two fixes, no change to what the shopper sees.

         1. The fetch below had no .catch(). When /cart.js answers with anything
            that is not JSON — a 429 rate-limit page is the usual one — .json()
            throws and nothing catches it, so the browser logs
            "Uncaught (in promise) SyntaxError". Harmless to the shopper, but it
            is the error that made a cart look broken when it was not. It now
            fails quietly and leaves the note exactly as it was.

         2. This ran once per mutation of .cart__footer, and the note itself
            lives inside that footer, so a single cart update fired a burst of
            /cart.js requests from here on top of the five other call sites in
            this file. Bursts like that are what earn a 429 in the first place.
            The work is now debounced and a request already in flight is not
            duplicated. */

      var memberNoteTimer = null;
      var memberNoteBusy  = false;

      function updateMemberNote() {
        if (memberNoteBusy) return;
        memberNoteBusy = true;
        fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(cart) {
          if (!cart || !cart.items) return;
          var hasMembership = cart.items.some(function(i) {
            return i.product_id === MEMBERSHIP_PRODUCT_ID;
          });
          var note = document.getElementById('gob-member-cart-note');
          if (note) note.style.display = hasMembership ? 'block' : 'none';
        })
        .catch(function () { /* offline, rate limited, or not JSON — leave the note alone */ })
        .then(function () { memberNoteBusy = false; });
      }

      /* coalesce a flurry of cart mutations into one request */
      function scheduleMemberNote() {
        clearTimeout(memberNoteTimer);
        memberNoteTimer = setTimeout(updateMemberNote, 150);
      }

      // Run on load
      updateMemberNote();

      // Re-run whenever cart changes (theme fires this event)
      document.addEventListener('cart:updated', scheduleMemberNote);
      document.addEventListener('ajaxProduct:added', scheduleMemberNote);
      document.addEventListener('CartDrawer:open', scheduleMemberNote);

      // Also observe DOM changes in the footer for quantity updates / removals
      var footer = document.querySelector('.cart__footer');
      if (footer) {
        new MutationObserver(scheduleMemberNote).observe(footer, { childList: true, subtree: true });
      }
    })();
    

/* ---------- block 1 (was inline #1) ---------- */
    // Set a cookie to expire in 15 minutes only if the cookie has not been previously set
    function setCookie() {
        var cookie = document.cookie.replace(/(?:(?:^|.*;\s*)expiration\s*=\s*([^;]*).*$)|^.*$/, "$1");
        if (!cookie) {
            var now = new Date();
            var time = now.getTime();
            time += 900000; // 15 minutes in milliseconds
            now.setTime(time);
            document.cookie = 'expiration=' + now.toUTCString() + '; max-age=3600'; // Set cookie to expire in 60 minutes
        }
    }

    // Get the time left before the cookie expires and display it in a textbox that refreshes each second
    function getTimeLeft() {
        var cookie = document.cookie.replace(/(?:(?:^|.*;\s*)expiration\s*=\s*([^;]*).*$)|^.*$/, "$1");
        if (cookie) {
            var expiration = new Date(cookie);
            var now = new Date();
            var timeLeft = expiration.getTime() - now.getTime();
            if (timeLeft > 0) {
                var minutesLeft = Math.floor((timeLeft / 1000) / 60);
                var secondsLeft = Math.floor((timeLeft / 1000) % 60);
                //console.log('setting remaining time');
                document.getElementById('timeLeft').textContent = formatTime(minutesLeft) + ':' + formatTime(secondsLeft);
            } else {
                clearInterval(interval); // Clear the interval when the cookie expires
                console.log('cookie expired');
                document.getElementById('checkout_timer').textContent = 'Limited quantities. Checkout now to avoid losing your deal.';
            }
        } 
    }

    // Format time to display in 2 digits
    function formatTime(time) {
        return time < 10 ? '0' + time : time;
    }

    // Set the cookie and get the time left before the cookie expires on page load
    setCookie();
    getTimeLeft();

    // Refresh the time left every second
    var interval = setInterval(getTimeLeft, 1000);

    // Checkbox for Shipping Insurance
    document.getElementById('wf_switch_btn').addEventListener('change', async function() {
      const checkbox = this; // Checkbox element
      const hiddenInput = document.querySelector('input[name="attributes[wf-switch]"]'); // Hidden input field

      // Images for toggling insurance image depending on checked status.
      const hasInsuranceImg = document.querySelector('.img-area .has-insurance');
      const noInsuranceImg = document.querySelector('.img-area .no-insurance');

      
      // Update the state of the hidden input based on checkbox
      if (checkbox.checked) {
        hiddenInput.value = 'true';
        hasInsuranceImg.style.display = 'block';
        noInsuranceImg.style.display = 'none'
      } else {
        hiddenInput.value = 'false';
        hasInsuranceImg.style.display = 'none';
        noInsuranceImg.style.display = 'block';
      }
    
    
      // Update the shipping insurance item in the cart
      await theme.updateShippingInsurance();
      
      // Submit the updated cart attribute
      await theme.submitCartAttribute('wf-switch', hiddenInput.value);
    });

    // Checkbox for Extended Warranty
    document.getElementById('xw_switch_btn').addEventListener('change', async function() {
      const checkbox_warranty = this; // Checkbox element
      const hiddenInput_warranty = document.querySelector('input[name="attributes[xw-switch]"]'); // Hidden input field

      // Images for toggling warranty image depending on checked status.
      const hasWarrantyImg = document.querySelector('.img-area .has-warranty');
      const noWarrantyImg = document.querySelector('.img-area .no-warranty');

      
      // Update the state of the hidden input based on checkbox
      if (checkbox_warranty.checked) {
        hiddenInput_warranty.value = 'true';
        hasWarrantyImg.style.display = 'block';
        noWarrantyImg.style.display = 'none'
      } else {
        hiddenInput_warranty.value = 'false';
        hasWarrantyImg.style.display = 'none';
        noWarrantyImg.style.display = 'block';
      }
    
    
      // Update the shipping warranty item in the cart
      await theme.updateExtendedWarranty();
      
      // Submit the updated cart attribute
      await theme.submitCartAttribute('xw-switch', hiddenInput_warranty.value);
    });

/* ---------- block 2 (was inline #2) ---------- */
(function(){
  function boot(){
    var cart = document.getElementById('HeaderCart');
    if (!cart || cart.dataset.gobSide) return;
    cart.dataset.gobSide = '1';

    /* escape the sticky header's transform context so position:fixed works */
    document.body.appendChild(cart);

    /* overlay */
    var ov = document.createElement('div');
    ov.id = 'gob-cart-overlay';
    document.body.appendChild(ov);
    ov.addEventListener('click', function(){
      document.dispatchEvent(new Event('cart:close'));
    });

    /* drawer header with close button */
    var anim = cart.querySelector('.site-header__drawer-animate');
    if (anim && !cart.querySelector('.gob-drawer-head')){
      var head = document.createElement('div');
      head.className = 'gob-drawer-head';
      head.innerHTML = '<b>Your Cart</b><button type="button" class="gob-drawer-close" aria-label="Close cart">&#10005;</button>';
      head.querySelector('button').addEventListener('click', function(){
        document.dispatchEvent(new Event('cart:close'));
      });
      anim.insertBefore(head, anim.firstChild);
    }

    /* sync overlay + scroll lock with the theme's own open/close class */
    new MutationObserver(function(){
      var open = cart.classList.contains('is-active');
      ov.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('gob-cart-lock', open);
    }).observe(cart, { attributes:true, attributeFilter:['class'] });
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ---------- block 3 (was inline #3) ---------- */
(function(){
  /* ── TUNE ──
     RENAME lets you show a friendlier name than the one in Shopify admin.
     Left side = exact discount title as Shopify reports it (case-insensitive).
     Right side = what the customer sees in the cart.
     Anything not listed here is shown exactly as Shopify names it. */
var RENAME = {
  '30% gob club member discount' : 'GOB Club',
  'gob club membership discount' : 'GOB Club',
  'gob club'                     : 'GOB Club'
};
  var FALLBACK_LABEL = 'Discount';        /* used only if Shopify reports no title at all */
  var SAVE_SUFFIX    = ' savings';        /* "GOB CLUB SAVINGS" / "WELCOME15 SAVINGS" */
  var SAVE_GENERIC   = 'Total savings';   /* used when more than one discount is active */
  var MEMBERSHIP_PRODUCT_ID = 10601114403149;

  function pretty(t){
    if(!t) return '';
    var k = t.toLowerCase().trim();
    return RENAME[k] || t;
  }

  /* the real discount name on a line item */
  function titleOf(item){
    var a = item.line_level_discount_allocations;
    if(a && a.length && a[0].discount_application && a[0].discount_application.title){
      return a[0].discount_application.title;
    }
    if(item.discounts && item.discounts.length && item.discounts[0].title){
      return item.discounts[0].title;
    }
    return '';
  }

  /* every distinct discount name active on the cart */
  function allTitles(cart){
    var seen = {}, out = [];
    (cart.items || []).forEach(function(it){
      var t = pretty(titleOf(it));
      if(t && !seen[t]){ seen[t] = 1; out.push(t); }
    });
    (cart.cart_level_discount_applications || []).forEach(function(d){
      var t = pretty(d.title || '');
      if(t && !seen[t]){ seen[t] = 1; out.push(t); }
    });
    return out;
  }

  /* format a cents value using the same shape as a price string already on the page.
     V97 (2026-09-30): the theme prints prices with superscript decimals
     ("$71<sup>40</sup>"), so a node's visible text reads "$7140" and carries no
     decimal separator. The old parser then fell back to a comma and printed
     "$71,40" / "−$38,10" on dollar stores. Now it looks for a well-formed price
     (the screen-reader copy "$71.40" sits in the same node); if the node has none
     (the subtotal has no hidden copy), it borrows the shape from any price in the
     cart. Only when nothing on the page is readable does it fall back to 0.00. */
  function priceShape(s){
    s = (s || '').replace(/\s+/g,' ');
    var m = s.match(/\d{1,3}(?:[.,\u00a0 ]\d{3})*[.,]\d{2}(?!\d)/);
    if(!m) return null;
    var num = m[0], before = s.slice(0, m.index), after = s.slice(m.index + num.length);
    var pre = (before.match(/[^\d\s]*$/) || [''])[0];
    var post = pre ? '' : (after.match(/^ ?[^\d\s]*/) || [''])[0];
    var dec = num.charAt(num.length - 3);
    return { pre: pre, post: post, dec: dec, thou: dec === ',' ? '.' : ',' };
  }
  function makeFormatter(raw){
    var sh = priceShape(raw);
    if(!sh){
      var nodes = document.querySelectorAll('.cart__item-price-col .visually-hidden, .cart__price .visually-hidden');
      for(var i = 0; i < nodes.length && !sh; i++) sh = priceShape(nodes[i].textContent);
    }
    if(!sh) return function(c){ return (c/100).toFixed(2); };
    return function(cents){
      var v = (cents/100).toFixed(2).split('.');
      return sh.pre + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, sh.thou) + sh.dec + v[1] + sh.post;
    };
  }

  /* strip any "(CODE)" suffix if the theme fills its own savings block */
  function cleanSavings(){
    document.querySelectorAll('[data-discounts] .cart__discount, .cart__discounts .cart__discount').forEach(function(n){
      var t = (n.textContent || '').replace(/\s+/g,' ').trim().replace(/\s*\([^()]*\)\s*$/, '');
      if(t && n.textContent.trim() !== t) n.textContent = t;
    });
  }

  /* ── total saved row above Subtotal ── */
  function paintSavings(cart){
    /* V153: the savings row grows in when a saving appears, rolls when the
       amount changes and folds away when it goes — no hard pops. */
    var S = window.GOBSmooth;
    var olds = [].slice.call(document.querySelectorAll('.gob-save-row'));
    var prevTxt = olds.length ? ((olds[0].querySelector('.gob-save-amt') || {}).textContent || null) : null;

    var total = 0;
    (cart.items || []).forEach(function(i){ total += (i.total_discount || 0); });
    if(cart.total_discount && cart.total_discount > total) total = cart.total_discount;
    if(total <= 0){
      olds.forEach(function(n){ if(S && S.fold && !n.__gone){ n.__gone = 1; S.fold(n, function(){ n.remove(); }); } else if(!S || !S.fold) n.remove(); });
      return;
    }
    olds.forEach(function(n){ n.remove(); });

    var names = allTitles(cart);
    var label = names.length === 1 ? (names[0] + SAVE_SUFFIX) : SAVE_GENERIC;

    document.querySelectorAll('.cart__item--subtotal').forEach(function(sub){
      var ref = sub.querySelector('[data-subtotal]');
      var fmt = makeFormatter(ref ? (ref.textContent || '').trim() : '');

      var row = document.createElement('div');
      row.className = 'gob-save-row';
      var l = document.createElement('span'); l.className = 'gob-save-label'; l.textContent = label;
      var a = document.createElement('span'); a.className = 'gob-save-amt';   a.textContent = '−' + fmt(total);
      row.appendChild(l); row.appendChild(a);
      sub.parentNode.insertBefore(row, sub);
      if(S){   /* V153 */
        if(prevTxt === null){ if(S.grow) S.grow(row); }
        else if(prevTxt !== a.textContent && S.rollTo){ var nt = a.textContent; a.textContent = prevTxt; S.rollTo(a, nt); }
      }
    });
  }

  /* ── per-item price lines ── */
  function paint(cart){
    if(!cart || !cart.items) return;
    cleanSavings();

    document.querySelectorAll('.cart__item[data-key]').forEach(function(row){
      var key = row.getAttribute('data-key');
      var item = null;
      for(var i=0;i<cart.items.length;i++){ if(cart.items[i].key === key){ item = cart.items[i]; break; } }
      if(!item) return;

      var col = row.querySelector('.cart__item-price-col');
      if(!col) return;

      col.querySelectorAll('.gob-mp-row,.gob-mp-label,.gob-mp-was,.gob-mp-now').forEach(function(n){ n.remove(); });

      /* never label the membership product itself */
      if(item.product_id === MEMBERSHIP_PRODUCT_ID){ row.classList.remove('gob-mp-on'); return; }

      var disc = item.total_discount || 0;
      var orig = item.original_line_price != null ? item.original_line_price : (item.price * item.quantity);
      if(disc <= 0 || orig <= 0){ row.classList.remove('gob-mp-on'); return; }

      var priceNode = col.querySelector('.cart__price') || col;
      var fmt = makeFormatter((priceNode.textContent || '').trim());
      var qty = item.quantity || 1;
      var was = Math.round(orig / qty);
      var now = Math.round((orig - disc) / qty);
      if(now >= was){ row.classList.remove('gob-mp-on'); return; }
      var pct = Math.round(disc / orig * 100);

      var wrap = document.createElement('div'); wrap.className = 'gob-mp-row';
      var a = document.createElement('span'); a.className = 'gob-mp-was'; a.textContent = fmt(was);
      var b = document.createElement('span'); b.className = 'gob-mp-now'; b.textContent = fmt(now);
      wrap.appendChild(a); wrap.appendChild(b);

      var name = pretty(titleOf(item)) || FALLBACK_LABEL;
      var c = document.createElement('small'); c.className = 'gob-mp-label';
      c.textContent = name + ' −' + pct + '%';

      col.insertBefore(c, col.firstChild);
      col.insertBefore(wrap, col.firstChild);
      row.classList.add('gob-mp-on');
    });

    paintSavings(cart);
  }

  var busy = false;
  function refresh(){
    if(busy) return;
    busy = true;
    fetch('/cart.js', { headers:{ 'Accept':'application/json' }, credentials:'same-origin' })
      .then(function(r){ return r.json(); })
      .then(paint)
      .catch(function(){})
      .then(function(){ busy = false; });
  }

  ['cart:updated','ajaxProduct:added','cart:open','CartDrawer:open'].forEach(function(ev){
    document.addEventListener(ev, function(){ setTimeout(refresh, 120); });
  });

  function watch(){
    var host = document.querySelector('#HeaderCart [data-products]') || document.querySelector('[data-products]');
    if(host) new MutationObserver(function(){ setTimeout(refresh, 60); }).observe(host, { childList:true, subtree:true });
    var foot = document.querySelector('.cart__footer');
    if(foot) new MutationObserver(function(){ setTimeout(refresh, 60); }).observe(foot, { childList:true, subtree:true });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ watch(); refresh(); });
  } else { watch(); refresh(); }
})();

/* ---------- block 4 (was inline #4) ---------- */
(function(){
  var MSG   = 'Your cart is reserved';
  var END   = 'Selling fast — complete your order to secure your items.';
  var TOTAL = 900;                   /* TUNE — seconds the drain bar is scaled to */

  var host = document.getElementById('checkout_timer'); if(!host) return;
  var lock = false, fill = null;

  function build(){
    if(lock) return;
    var expired = /limited quantities/i.test(host.textContent || '');
    if(host.querySelector('.gob-ut-top') && !expired) return;

    var t = document.getElementById('timeLeft'), val = t ? t.textContent : '';
    lock = true;
    host.textContent = '';

    var top = document.createElement('div'); top.className = 'gob-ut-top';
    var m   = document.createElement('span'); m.className = 'gob-ut-msg'; m.textContent = expired ? END : MSG;
    var s   = document.createElement('span'); s.id = 'timeLeft'; s.textContent = val;
    if(expired) s.style.display = 'none';
    top.appendChild(m); top.appendChild(s);
    host.appendChild(top);

    fill = null;
    if(!expired){
      var tr = document.createElement('div'); tr.className = 'gob-ut-track';
      fill = document.createElement('div');   fill.className = 'gob-ut-fill';
      tr.appendChild(fill); host.appendChild(tr);
    }
    lock = false;
  }

  function tick(){
    var t = document.getElementById('timeLeft');
    if(!t || !fill) return;
    var p = (t.textContent || '').split(':');
    if(p.length !== 2) return;
    var sec = (parseInt(p[0],10)||0)*60 + (parseInt(p[1],10)||0);
    fill.style.width = Math.max(0, Math.min(100, sec / TOTAL * 100)) + '%';
  }

  build(); tick();
  /* V152: only tick while the drawer is open; catch up the moment it opens */
  setInterval(function(){ if(document.documentElement.classList.contains('cart-open')) tick(); }, 1000);
  document.addEventListener('CartDrawer:open', tick);
  new MutationObserver(build).observe(host, { childList:true });
})();

/* ---------- block 5 (was inline #5) ---------- */
(function(){
  var MINUTES = 15;                                     /* TUNE — keep TOTAL above = MINUTES × 60 */
  var ADDON   = /shipping insurance|extended warranty/i; /* TUNE — add-on product titles */
  var EXPIRED_TEXT = 'Limited quantities. Checkout now to avoid losing your deal.';

  var host = document.getElementById('checkout_timer'); if(!host) return;

  /* stop the theme's original ticker */
  try { if(window.interval) clearInterval(window.interval); } catch(e){}

  function read(){
    var m = document.cookie.match(/(?:^|;\s*)expiration\s*=\s*([^;]*)/);
    return m ? m[1] : '';
  }
  function write(){
    var d = new Date(Date.now() + MINUTES*60000);
    document.cookie = 'expiration=' + d.toUTCString() + '; max-age=' + (MINUTES*60) + '; path=/';
  }
  function drop(){
    document.cookie = 'expiration=; max-age=0; path=/';
    document.cookie = 'expiration=; max-age=0';   /* kill any old path-scoped cookie too */
  }
  function pad(n){ return n < 10 ? '0' + n : '' + n; }

  var mine = null;

  function show(){ host.style.display = 'block'; }
  function hide(){ host.style.display = 'none';  }

  function ensure(){
    if(!document.getElementById('timeLeft')){
      host.textContent = '';
      var s = document.createElement('span'); s.id = 'timeLeft';
      host.appendChild(s);
    }
  }

  function tick(){
    var c = read(); if(!c) return;
    var left = new Date(c).getTime() - Date.now();
    var el = document.getElementById('timeLeft');
    if(left > 0){
      if(el) el.textContent = pad(Math.floor(left/60000)) + ':' + pad(Math.floor(left/1000) % 60);
    } else {
      if(mine){ clearInterval(mine); mine = null; }
      drop();
      host.textContent = EXPIRED_TEXT;   /* Part 1 restyles this automatically */
    }
  }

  /* V152: the clock is only painted while the drawer is open */
  function gated(){ if(document.documentElement.classList.contains('cart-open')) tick(); }
  document.addEventListener('CartDrawer:open', function(){ if(mine) tick(); });

  function start(){
    ensure();
    if(!read()) write();
    if(!mine){ tick(); mine = setInterval(gated, 1000); }
    show();
  }
  function stop(){
    if(mine){ clearInterval(mine); mine = null; }
    drop();
    hide();
  }

  /* how many real products are in the cart, ignoring add-ons */
  function products(cart){
    var n = 0;
    (cart.items || []).forEach(function(it){
      var t = it.product_title || it.title || '';
      if(!ADDON.test(t)) n += (it.quantity || 0);
    });
    return n;
  }

  function sync(){
    fetch('/cart.js', { headers:{ 'Accept':'application/json' }, credentials:'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){ if(products(cart) > 0){ start(); } else { stop(); } })
      .catch(function(){});
  }

  /* hidden until proven otherwise — kills the leftover inline display:block */
  hide();
  sync();

  ['ajaxProduct:added','cart:updated'].forEach(function(ev){
    document.addEventListener(ev, function(){ setTimeout(sync, 150); });
  });
})();

/* ---------- block 6 (was inline #6) ---------- */
(function(){
  /* ══════════ TUNE — put your real numbers here ══════════ */
  var RATING = '4,8';

  /* Copy shown on desktop and on mobile. Mobile is the short one. */
  var LONG   = '300,000+ builders';
  var SHORT  = '300,000+';

  /* SWAP OPTION — if you would rather show the review count here
     (because the big rating block above already says 300,000+ builders),
     change the two lines above to:
       var LONG  = '(12,480 reviews)';
       var SHORT = '(12,480)';
     Nothing else needs to change. */

  /* add-on products are line items, so they must not count as products */
  var ADDON = /shipping insurance|extended warranty/i;
  /* ═══════════════════════════════════════════════════════ */

  var MARKS =
    '<span class="mk"><svg width="25" height="9" viewBox="0 0 26 9">'
  + '<text x="0" y="8" font-family="Helvetica,Arial" font-size="9" font-weight="700" font-style="italic" fill="#1434CB">VISA</text>'
  + '</svg></span>'

  + '<span class="mk"><svg width="19" height="12" viewBox="0 0 20 12">'
  + '<circle cx="7.5" cy="6" r="5.2" fill="#EB001B"></circle>'
  + '<circle cx="12.5" cy="6" r="5.2" fill="#F79E1B" opacity=".85"></circle>'
  + '</svg></span>'

  + '<span class="mk"><svg width="29" height="10" viewBox="0 0 30 10">'
  + '<text x="0" y="9" font-family="Helvetica,Arial" font-size="9" font-weight="700" font-style="italic" fill="#003087">Pay</text>'
  + '<text x="16" y="9" font-family="Helvetica,Arial" font-size="9" font-weight="700" font-style="italic" fill="#009CDE">Pal</text>'
  + '</svg></span>'

  + '<span class="mk"><svg width="29" height="12" viewBox="0 0 30 12">'
  + '<path transform="translate(0,0.4) scale(0.62)" fill="#101123" d="M12.5 8.4c0-1.6 1.3-2.4 1.4-2.4-.8-1.1-2-1.3-2.4-1.3-1-.1-2 .6-2.5.6s-1.3-.6-2.2-.6c-1.1 0-2.2.7-2.8 1.7-1.2 2.1-.3 5.2.9 6.9.6.8 1.3 1.8 2.2 1.7.9 0 1.2-.6 2.3-.6s1.4.6 2.3.5c.9 0 1.5-.8 2.1-1.7.7-1 .9-1.9.9-2-.1 0-1.8-.7-1.8-2.8zM10.9 3.3c.5-.6.8-1.4.7-2.2-.7 0-1.5.5-2 1.1-.4.5-.8 1.3-.7 2.1.8.1 1.6-.4 2-1z"></path>'
  + '<text x="11" y="9.5" font-family="Helvetica,Arial" font-size="9" font-weight="600" fill="#101123">Pay</text>'
  + '</svg></span>';

  function realProducts(){
    var n = 0;
    document.querySelectorAll('.cart__item[data-key]').forEach(function(row){
      var t = (row.textContent || '');
      if(!ADDON.test(t)) n++;
    });
    return n;
  }

  function build(){
    var wrap = document.createElement('div');
    wrap.className = 'gob-v2';
    wrap.innerHTML =
        '<span class="gob-v2-rt">'
      +   '<span class="s">&#9733;</span> ' + RATING + ' &middot; '
      +   '<span class="m">'
      +     '<span class="gob-v2-long">'  + LONG  + '</span>'
      +     '<span class="gob-v2-short">' + SHORT + '</span>'
      +   '</span>'
      + '</span>'
      + '<span class="gob-v2-div"></span>'
      + '<span class="gob-v2-pm">' + MARKS + '</span>';
    return wrap;
  }

  function paint(){
    document.querySelectorAll('.gob-v2').forEach(function(n){ n.remove(); });
    if(realProducts() < 1) return;          /* never on an empty cart */

    document.querySelectorAll('.cart__footer').forEach(function(foot){
      if(foot.querySelector('.gob-v2')) return;

      var btns = foot.querySelector('.payment-buttons');
      if(btns && btns.parentNode){
        /* directly under the Check out button */
        btns.parentNode.insertBefore(build(), btns.nextSibling);
      } else {
        foot.appendChild(build());
      }
    });
  }

  var busy = false;
  function refresh(){
    if(busy) return;
    busy = true;
    setTimeout(function(){ paint(); busy = false; }, 60);
  }

  ['cart:updated','ajaxProduct:added','cart:open','CartDrawer:open'].forEach(function(ev){
    document.addEventListener(ev, function(){ setTimeout(refresh, 140); });
  });

  function watch(){
    var host = document.querySelector('#HeaderCart [data-products]') || document.querySelector('[data-products]');
    if(host) new MutationObserver(refresh).observe(host, { childList:true, subtree:true });

    var foot = document.querySelector('.cart__footer');
    if(foot) new MutationObserver(function(m){
      for(var i=0;i<m.length;i++){
        for(var j=0;j<m[i].addedNodes.length;j++){
          var n = m[i].addedNodes[j];
          if(n.nodeType === 1 && n.classList && n.classList.contains('gob-v2')) return;
        }
      }
      refresh();
    }).observe(foot, { childList:true, subtree:true });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ watch(); refresh(); });
  } else { watch(); refresh(); }
})();

/* ---------- block 7 (was inline #7) ---------- */
(function(){
  /* ══════════ TUNE ══════════ */

  /* Mobile only. Set to 99999 to make it apply on every screen size. */
  var MAX_WIDTH = 749;

  /* If the tab still shows, right-click it in Chrome, choose Inspect, and
     copy the class of the outer box. Paste it here, e.g. '.my-teaser-class'.
     Leave the quotes empty if you do not need it. */
  var EXTRA = '';

  /* ══════════════════════════ */

  var SEL = [
    '.klaviyo-form',
    '[class*="klaviyo-form"]',
    'div[class*="kl-private-reset-css"]',
    '[class*="kl-teaser"]',
    '[data-testid="teaser-container"]',
    '[data-testid="TEASER"]'
  ];
  if(EXTRA) SEL.push(EXTRA);
  var SELECTOR = SEL.join(',');

  var stash = [];
  var isOpen = false;

  /* V153: a cached media query — reading innerWidth here forced a layout on
     every drawer event (~75 ms per Add to cart on a phone) */
  var MQ = window.matchMedia ? window.matchMedia('(max-width: ' + MAX_WIDTH + 'px)') : null;
  function mobile(){ return MQ ? MQ.matches : window.innerWidth <= MAX_WIDTH; }

  /* Klaviyo sets display inline, so CSS alone can lose the fight.
     We remember the exact inline value and put it back on close. */
  function force(){
    document.querySelectorAll(SELECTOR).forEach(function(el){
      if(el.getAttribute('data-gob-hidden')) return;
      stash.push([
        el,
        el.style.getPropertyValue('display'),
        el.style.getPropertyPriority('display')
      ]);
      el.setAttribute('data-gob-hidden','1');
      el.style.setProperty('display','none','important');
    });
  }

  function unforce(){
    stash.forEach(function(rec){
      var el = rec[0], val = rec[1], pri = rec[2];
      el.removeAttribute('data-gob-hidden');
      el.style.removeProperty('display');
      if(val) el.style.setProperty('display', val, pri);
    });
    stash = [];
  }

  function open(){
    if(isOpen) return;
    isOpen = true;
    document.documentElement.classList.add('gob-cart-open');
    if(mobile()) force();
  }

  function close(){
    if(!isOpen) return;
    isOpen = false;
    document.documentElement.classList.remove('gob-cart-open');
    unforce();
  }

  /* Is the drawer actually on screen right now?
     Closed drawers are usually pushed off with transform, so their box
     sits at or past the right edge of the window. */
  function drawerVisible(){
    var d = document.querySelector('#HeaderCart');
    if(!d) return false;
    /* V152: no style/layout read while the drawer is plainly shut */
    if(!d.classList.contains('is-active') && !document.documentElement.classList.contains('cart-open')) return false;
    if(d.classList.contains('is-active')) return true;   /* V153: open is open — no style/layout read (~95 ms per tap) */

    var cs = window.getComputedStyle(d);
    if(cs.display === 'none' || cs.visibility === 'hidden') return false;
    if(parseFloat(cs.opacity || '1') < 0.05) return false;

    var r = d.getBoundingClientRect();
    if(r.width < 20 || r.height < 20) return false;
    if(r.left >= window.innerWidth - 20) return false;   /* slid off right */
    if(r.right <= 20) return false;                      /* slid off left  */
    return true;
  }

  function sync(){
    if(drawerVisible()) open(); else close();
  }

  /* re-check a few times across the open/close animation */
  function nudge(){
    [0, 120, 340, 700].forEach(function(ms){ setTimeout(sync, ms); });
  }

  ['cart:open','CartDrawer:open','cart:updated','ajaxProduct:added',
   'cart:close','CartDrawer:close'].forEach(function(ev){
    document.addEventListener(ev, nudge);
  });

  /* V152: was document.addEventListener('click', nudge, true) — four layout reads
     after every tap anywhere on the page. Open/close is already caught by the
     events above and the class observer below. */
  window.addEventListener('resize', sync);
  document.addEventListener('transitionend', function(e){
    if(e.target && e.target.id === 'HeaderCart') sync();
  });

  function watch(){
    var d = document.querySelector('#HeaderCart');
    if(d){
      new MutationObserver(sync).observe(d, {
        attributes:true, attributeFilter:['class','style','aria-hidden','open']
      });
    }
    new MutationObserver(function(){
      if(isOpen && mobile()) force();      /* Klaviyo injected late */
    }).observe(document.body, { childList:true, subtree:false });

    ['class','style'].forEach(function(){});
    /* V152: one check per frame, not one per attribute write */
    var rq = 0;
    new MutationObserver(function(){ if(rq) return; rq = requestAnimationFrame(function(){ rq = 0; sync(); }); }).observe(document.body, {
      attributes:true, attributeFilter:['class','style']
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ watch(); nudge(); });
  } else { watch(); nudge(); }
})();

/* ---------- block 8 (was inline #8) ---------- */
(function(){
  /* ══════════ TUNE ══════════ */

  /* Shorter wording. Keep the VAT part — except UK / Isle of Man, where we are
     not UK-VAT registered yet, so the line must not mention VAT at all.
     Remove the GB/IM branch once UK VAT is registered and collected. */
  var GOB_CC = String(window.GOB_COUNTRY || (window.Shopify && window.Shopify.country) || '').toUpperCase();
  var TEXT = (GOB_CC === 'GB' || GOB_CC === 'IM')
    ? 'Discount codes applied at checkout'
    : 'VAT included · Discount codes applied at checkout';

  /* Set to true to remove the line completely instead of shrinking it. */
  var REMOVE = false;

  /* ══════════════════════════ */

  var MATCH = /(vat|taxes?)\b/i;
  var ALSO  = /discount/i;

  function tidy(){
    document.querySelectorAll('.cart__footer').forEach(function(foot){
      var nodes = foot.querySelectorAll('p, small, span, div');

      for(var i = 0; i < nodes.length; i++){
        var el = nodes[i];

        /* never touch our own blocks */
        if(el.closest('.gob-v2, .gob-r2, .payment-buttons, .cart__item')) continue;
        if(el.classList.contains('gob-taxline')) continue;

        /* leaf-ish only, so we do not grab a whole wrapper */
        if(el.querySelector('p, small, div, button, a, svg')) continue;

        var t = (el.textContent || '').trim();
        if(t.length < 8 || t.length > 140) continue;
        if(!MATCH.test(t)) continue;
        if(!ALSO.test(t) && t.length > 60) continue;

        if(REMOVE){
          el.style.setProperty('display','none','important');
        } else {
          el.classList.add('gob-taxline');
          if(TEXT && el.textContent.trim() !== TEXT) el.textContent = TEXT;
        }
      }
    });
  }

  var busy = false;
  function refresh(){
    if(busy) return;
    busy = true;
    setTimeout(function(){ tidy(); busy = false; }, 80);
  }

  ['cart:updated','ajaxProduct:added','cart:open','CartDrawer:open'].forEach(function(ev){
    document.addEventListener(ev, function(){ setTimeout(refresh, 140); });
  });

  function watch(){
    var foot = document.querySelector('.cart__footer');
    if(foot) new MutationObserver(refresh).observe(foot, { childList:true, subtree:true });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ watch(); refresh(); });
  } else { watch(); refresh(); }
})();

/* ---------- block 9 (was inline #9) ---------- */
(function(){
  /* ══════════ TUNE ══════════ */

  /* The accessories offered under each light kit, in the order they appear.
       key      — short id, must be unique, used for caching. Do not reuse.
       headline — the bold line on the card.
       query    — what to type into the shop search. Several terms are tried
                  in order until one finds something, so you do not have to
                  know the exact product naming.
       match    — the product title must match this to be accepted.
       exclude  — and must NOT match this. Stops a nameplate being offered
                  as a wall mount and the other way round. */
  /* The two title patterns, kept in one place. These allow a hyphen, so
     "Display Wall-Mount for Bugatti Chiron 42083" is recognised. */
  var WALL  = /wall[\s\-_]*mount|wall[\s\-_]*display|display[\s\-_]*wall|display[\s\-_]*mount|wall[\s\-_]*bracket|wall[\s\-_]*frame/i;
  var PLATE = /name[\s\-_]*plate/i;

  /* An empty query term '' means "search the set number on its own and let
     the match pattern decide" — the catch-all that finds oddly named products. */
  var OFFERS = [
    {
      key:'np',
      headline:'Made for this exact set',
      query:['nameplate', 'name plate', ''],
      match:PLATE,
      exclude:WALL
    },
    {
      key:'wm',
      headline:'Put it on the wall',
      query:['wall mount', 'display wall-mount', 'wall display', ''],
      match:WALL,
      exclude:PLATE
    }
  ];

  var BTN = 'ADD';

  /* Safety caps so a big cart cannot fill the drawer with offers. */
  var MAX_ITEMS   = 4;   /* how many different sets may show offers */
  var MAX_BANNERS = 6;   /* hard ceiling on cards on screen at once */

  /* add-on products are line items, so they must not be treated as products */
  var ADDON = /shipping insurance|extended warranty|gob club membership/i;

  /* Leave empty unless prices come out wrong. Then paste your
     money format from Shopify admin, e.g. '&euro;{{amount_with_comma_separator}}' */
  var MONEY_FORMAT = '';

  /* ══════════════════════════ */

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var BASE = ROOT.replace(/\/$/, '');
  /* bump this letter if you ever change the search rules above — it throws
     away the browser's remembered misses so the new rules get a clean run */
  var CACHE_KEY = 'gob_off_b_';
  var busy = false;

  /* ── money ─────────────────────────────────────────────── */
  function moneyFormat(){
    if(MONEY_FORMAT) return MONEY_FORMAT;
    if(window.Shopify && window.Shopify.money_format) return window.Shopify.money_format;
    if(window.theme && window.theme.moneyFormat) return window.theme.moneyFormat;
    if(window.theme && window.theme.settings && window.theme.settings.moneyFormat) return window.theme.settings.moneyFormat;
    return '&euro;{{amount_with_comma_separator}}';
  }

  function group(num, thousand, decimal){
    if(isNaN(num) || num === null) return '0';
    num = (num / 100).toFixed(2);
    var parts = num.split('.');
    var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousand);
    return head + decimal + parts[1];
  }

  function money(cents){
    var fmt = moneyFormat();
    var out;
    if(/amount_no_decimals_with_comma_separator/.test(fmt)){
      out = group(cents, '.', ',').replace(/[.,]\d\d$/, '');
    } else if(/amount_with_comma_separator/.test(fmt)){
      out = group(cents, '.', ',');
    } else if(/amount_no_decimals/.test(fmt)){
      out = group(cents, ',', '.').replace(/[.,]\d\d$/, '');
    } else {
      out = group(cents, ',', '.');
    }
    var txt = fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
    var box = document.createElement('div');
    box.innerHTML = txt;
    return (box.textContent || out).trim();
  }

  /* ── cart reading ──────────────────────────────────────── */
  function setNumber(title){
    var m = String(title || '').match(/\b(\d{5,6})\b/) || String(title || '').match(/\b(\d{4})\b/);
    return m ? m[1] : '';
  }

  /* is this cart row itself one of the accessories we offer? */
  function isAccessory(text){
    for(var i = 0; i < OFFERS.length; i++){
      if(OFFERS[i].match.test(text)) return OFFERS[i].key;
    }
    return '';
  }

  function cartRows(){
    var out = [];
    document.querySelectorAll('.cart__item[data-key]').forEach(function(row){
      var txt = (row.textContent || '').replace(/\s+/g, ' ').trim();
      if(ADDON.test(txt)) return;
      out.push({ el: row, text: txt, num: setNumber(txt), acc: isAccessory(txt) });
    });
    return out;
  }

  /* the live kit row for a set number, re-queried at insert time */
  function rowFor(num){
    var found = null;
    cartRows().forEach(function(r){
      if(found) return;
      if(r.num === num && !r.acc) found = r.el;
    });
    return found;
  }

  /* ── catalogue lookup ──────────────────────────────────── */
  function cached(key){
    try{
      var raw = sessionStorage.getItem(CACHE_KEY + key);
      return raw ? JSON.parse(raw) : null;
    }catch(e){ return null; }
  }
  function cache(key, val){
    try{ sessionStorage.setItem(CACHE_KEY + key, JSON.stringify(val)); }catch(e){}
  }

  /* one search attempt — resolves to a product summary or null */
  function trySearch(term, num, offer){
    var q = (term + ' ' + num).trim();
    var url = BASE + '/search/suggest.json?q=' + encodeURIComponent(q)
            + '&resources[type]=product&resources[limit]=' + (term ? 10 : 20)
            + '&resources[options][fields]=title,product_type,variants.title,variants.sku,tag';

    return fetch(url, { headers:{ 'Accept':'application/json' } })
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(j){
        var list = j && j.resources && j.resources.results && j.resources.results.products;
        if(!list || !list.length) return null;

        for(var i = 0; i < list.length; i++){
          var t = list[i].title || '';
          if(t.indexOf(num) === -1) continue;
          if(!offer.match.test(t)) continue;
          if(offer.exclude && offer.exclude.test(t)) continue;
          return list[i];
        }
        return null;
      })
      /* V155: a failed request is NOT "no nameplate exists". Report it as an
         error so the miss is not remembered for the rest of the session. */
      .catch(function(){ return { _err:true }; });
  }

  /* walk the query terms in order until one of them finds the product */
  function search(offer, num, i){
    i = i || 0;
    if(i >= offer.query.length) return Promise.resolve(null);
    return trySearch(offer.query[i], num, offer).then(function(hit){
      if(hit && hit._err) return hit;
      return hit || search(offer, num, i + 1);
    });
  }

  function findOffer(offer, num){
    var ck = offer.key + '_' + num;
    var hit = cached(ck);
    if(hit) return Promise.resolve(hit.none ? null : hit);

    if(pending[ck]) return pending[ck];
    return (pending[ck] = search(offer, num).then(function(match){
      if(match && match._err){ delete pending[ck]; return null; }   /* try again next paint */
      if(!match){ cache(ck, { none:true }); return null; }

      return fetch(BASE + '/products/' + match.handle + '.js', { headers:{ 'Accept':'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){
          if(!p || !p.variants) throw 0;
          var v = null;
          for(var i = 0; i < p.variants.length; i++){
            if(p.variants[i].available){ v = p.variants[i]; break; }
          }
          if(!v) throw 0;                       /* out of stock — stay silent */

          var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
          if(img && img.indexOf('//') === 0) img = 'https:' + img;
          if(img) img = img.split('?')[0] + '?width=120';

          var rec = {
            id: v.id, title: p.title, price: v.price, img: img,
            handle: p.handle, num: num, key: offer.key, headline: offer.headline
          };
          cache(ck, rec);
          return rec;
        })
        .catch(function(){ return null; });
    }).then(function(rec){ delete pending[ck]; return rec; }));
  }
  var pending = {};

  /* ── keeping the drawer alive after an add ───────────────
     The theme renders the cart rows with its own JavaScript — the Liquid
     for the list is literally <div data-products></div>. So we must NOT
     write into it ourselves.
     This theme (Archetype) rebuilds from a cart OBJECT handed to it in the
     event detail — an empty detail makes it bail silently. So we fetch
     /cart.js first and hand the real cart over, and we also call the theme's
     own rebuild function directly if we can find it.
     There is NO page reload anywhere in here. A reload is what was slamming
     the drawer shut. Worst case the row appears a moment late. */

  function getCart(){
    return fetch(BASE + '/cart.js', { headers:{ 'Accept':'application/json' }, credentials:'same-origin' })
      .then(function(r){ return r.json(); })
      .catch(function(){ return null; });
  }

  function fire(cart){
    var detail = cart ? { cart:cart } : {};

    ['cart:updated','cart:build','cart:refresh','ajaxProduct:added'].forEach(function(ev){
      try{ document.dispatchEvent(new CustomEvent(ev, { detail:detail, bubbles:true })); }catch(e){}
    });

    if(cart && window.theme){
      var t = window.theme;
      [ t.cart, t.CartDrawer, t.cartDrawer, t.Cart ].forEach(function(o){
        if(!o) return;
        ['buildCart','updateCart','renderCart','build','refresh'].forEach(function(fn){
          if(typeof o[fn] === 'function'){ try{ o[fn](cart); }catch(e){} }
        });
      });
    }
  }

  function domCount(){
    return document.querySelectorAll('.cart__item[data-key]').length;
  }

  function patchTotal(cart){
    if(!cart) return;
    if(window.GOBSmooth) return;   /* V152: the drawer paint rolls the subtotal in the theme's own format */
    document.querySelectorAll('#HeaderCart [data-subtotal]').forEach(function(el){
      try{ el.textContent = money(cart.total_price); }catch(e){}
    });
  }

  var inflight = {};

  function done(id){
    if(id) inflight[id] = false;
    refresh();
  }

  /* TUNE — how long to wait for the theme to draw the new row.
     STEPS × 400ms. 10 = four seconds. After that we simply stop waiting. */
  var STEPS = 10;

  function settle(step, id){
    return getCart().then(function(cart){
      if(!cart){ done(id); return; }

      patchTotal(cart);

      if(domCount() === (cart.items || []).length){ done(id); return; }

      if(step < STEPS){
        if(step === 2 || step === 5) fire(cart);
        return new Promise(function(go){ setTimeout(go, 400); })
               .then(function(){ return settle(step + 1, id); });
      }

      /* theme never drew it. The item IS in the cart and the total is right.
         Stop here — do not reload, do not touch the drawer. */
      done(id);
    });
  }

  /* Locked per button, not globally, so adding a wall mount while the
     nameplate is still settling works instead of being silently ignored. */
  /* 2026-09-26 — upsell tracking. The line carries a hidden property
     _gob_upsell = "cart:nameplate" / "cart:wallmount" (underscore = never shown
     to the shopper). Shopify Flow turns it into order tags upsell-cart-*. */
  var UPSELL_KIND = { np:'nameplate', wm:'wallmount' };

  function addToCart(id, btn, key){
    if(inflight[id]) return;
    inflight[id] = true;
    if(btn){ btn.setAttribute('disabled','disabled'); btn.textContent = 'ADDING…'; }

    fetch(BASE + '/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      credentials:'same-origin',
      body: JSON.stringify({ items:[{ id:id, quantity:1,
        properties:{ _gob_upsell: 'cart:' + (UPSELL_KIND[key] || key || 'addon') } }] })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      if(btn) btn.textContent = 'ADDED';
      return getCart().then(function(cart){
        fire(cart);
        patchTotal(cart);
        return settle(0, id);
      });
    })
    .catch(function(){
      inflight[id] = false;
      if(btn){ btn.removeAttribute('disabled'); btn.textContent = BTN; }
    });
  }

  /* ── rendering ─────────────────────────────────────────── */
  function build(rec){
    var wrap = document.createElement('div');
    wrap.className = 'gob-np';
    wrap.setAttribute('data-num', rec.num);
    wrap.setAttribute('data-off', rec.key);

    var img = document.createElement('img');
    img.className = 'gob-np-img';
    img.loading = 'lazy';
    img.alt = '';
    if(rec.img) img.src = rec.img;

    var cp = document.createElement('div');
    cp.className = 'gob-np-cp';

    var h = document.createElement('p');
    h.className = 'gob-np-h';
    h.textContent = rec.headline;

    var t = document.createElement('p');
    t.className = 'gob-np-t';
    t.appendChild(document.createTextNode(rec.title + ' · '));
    var b = document.createElement('b');
    b.textContent = money(rec.price);
    t.appendChild(b);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gob-np-add';
    btn.textContent = BTN;
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      addToCart(rec.id, btn, rec.key);
    });

    cp.appendChild(h);
    cp.appendChild(t);
    wrap.appendChild(img);
    wrap.appendChild(cp);
    wrap.appendChild(btn);
    return wrap;
  }

  /* all banners currently sitting directly under a given kit row */
  function bannersUnder(row, num){
    var out = [];
    var n = row ? row.nextSibling : null;
    while(n && n.nodeType === 1 && n.classList &&
          n.classList.contains('gob-np') && n.getAttribute('data-num') === num){
      out.push(n);
      n = n.nextSibling;
    }
    return out;
  }

  /* first card gets the elbow, the rest get the short connector */
  function restripe(num){
    var row = rowFor(num);
    bannersUnder(row, num).forEach(function(n, i){
      n.classList.toggle('gob-np--first', i === 0);
      n.classList.toggle('gob-np--more',  i > 0);
    });
  }

  /* is this banner still correctly attached to its kit row? */
  function attached(n){
    var num = n.getAttribute('data-num');
    var p = n.previousSibling;
    while(p && p.nodeType === 1 && p.classList &&
          p.classList.contains('gob-np') && p.getAttribute('data-num') === num){
      p = p.previousSibling;
    }
    return !!p && p === rowFor(num);
  }

  function place(rec){
    var sel = '.gob-np[data-off="' + rec.key + '"][data-num="' + rec.num + '"]';
    if(document.querySelector(sel)) return;

    var row = rowFor(rec.num);
    if(!row || !row.parentNode) return;      /* kit removed while fetching */

    var mine = bannersUnder(row, rec.num);
    var anchor = mine.length ? mine[mine.length - 1] : row;
    var nb = build(rec);
    row.parentNode.insertBefore(nb, anchor.nextSibling);
    if(window.GOBSmooth && GOBSmooth.grow) GOBSmooth.grow(nb);   /* V153 */
    restripe(rec.num);
  }

  function paint(){
    var rows = cartRows();
    if(!rows.length){
      document.querySelectorAll('.gob-np').forEach(function(n){ n.remove(); });
      return;
    }

    /* which accessories are already in the cart, per set number */
    var have = {};
    rows.forEach(function(r){
      if(r.acc && r.num) have[r.acc + '_' + r.num] = true;
    });

    /* which set numbers are actual kits sitting in the cart */
    var kits = [];
    rows.forEach(function(r){
      if(!r.num || r.acc) return;
      if(kits.indexOf(r.num) === -1) kits.push(r.num);
    });
    kits = kits.slice(0, MAX_ITEMS);

    /* the full wanted list, kit by kit, offer by offer */
    var wanted = [];
    kits.forEach(function(num){
      OFFERS.forEach(function(offer){
        if(have[offer.key + '_' + num]) return;
        wanted.push({ num:num, offer:offer, id:offer.key + '_' + num });
      });
    });
    wanted = wanted.slice(0, MAX_BANNERS);

    var ids = wanted.map(function(w){ return w.id; });

    /* drop banners that are no longer wanted, or that drifted away from
       their row after a theme re-render */
    var touched = {};
    document.querySelectorAll('.gob-np').forEach(function(n){
      if(n.__gone) return;
      var id = n.getAttribute('data-off') + '_' + n.getAttribute('data-num');
      touched[n.getAttribute('data-num')] = true;
      if(ids.indexOf(id) === -1){   /* V153: an offer that was just taken folds away */
        if(window.GOBSmooth && GOBSmooth.fold){ n.__gone = 1; GOBSmooth.fold(n, function(){ n.remove(); }); } else n.remove();
        return;
      }
      if(!attached(n)){ n.remove(); }
    });
    Object.keys(touched).forEach(restripe);

    wanted.forEach(function(w){
      var sel = '.gob-np[data-off="' + w.offer.key + '"][data-num="' + w.num + '"]';
      if(document.querySelector(sel)) return;
      findOffer(w.offer, w.num).then(function(rec){ if(rec) place(rec); });
    });
  }

  /* V155: calls that arrive while a paint is queued are no longer dropped.
     The last one always runs, so the final drawer render is never missed. */
  var again = false;
  function refresh(){
    if(busy){ again = true; return; }
    busy = true;
    setTimeout(function(){
      paint(); busy = false;
      if(again){ again = false; refresh(); }
    }, 70);
  }

  /* V155: after an add the theme redraws the rows a few times (placeholder row,
     then the real row, then the totals). Check again on a short ladder so the
     offer for a newly added kit shows up the moment its row exists. */
  function ladder(){ [160, 450, 900, 1600, 2800].forEach(function(t){ setTimeout(refresh, t); }); }
  ['cart:updated','ajaxProduct:added','cart:open','CartDrawer:open'].forEach(function(ev){
    document.addEventListener(ev, ladder);
  });

  /* V155: on a product page, look the offers up before Add to cart is even
     pressed, so the card can appear together with the kit row. */
  function warm(){
    var h = document.querySelector('h1');
    var t = h ? h.textContent : '';
    var num = setNumber(t);
    if(!num || isAccessory(t) || !/light kit/i.test(t)) return;
    OFFERS.forEach(function(o){ findOffer(o, num); });
  }
  (window.requestIdleCallback || function(f){ setTimeout(f, 1500); })(warm);

  function watch(){
    /* V155: watch the whole drawer, which is never replaced, rather than the
       row list, which the theme can swap out — that left the observer
       watching a detached node and the next kit got no card until reopen. */
    var box = document.querySelector('#HeaderCart')
           || document.querySelector('[data-products]');
    if(!box) return;
    new MutationObserver(function(m){
      var hit = false;
      for(var i=0;i<m.length;i++){
        /* only changes to the row list matter — not the countdown, totals or buttons */
        var tg = m[i].target;
        if(!tg || tg.nodeType !== 1) continue;
        if(!(tg.closest && tg.closest('[data-products], .cart__items')) &&
           !(tg.querySelector && tg.querySelector('[data-products], .cart__items'))) continue;
        for(var j=0;j<m[i].addedNodes.length;j++){
          var n = m[i].addedNodes[j];
          if(n.nodeType === 1 && n.classList && n.classList.contains('gob-np')) return;
        }
        for(var k=0;k<m[i].removedNodes.length;k++){
          var x = m[i].removedNodes[k];
          if(x.nodeType === 1 && x.classList && x.classList.contains('gob-np')) return;
        }
        hit = true;
      }
      if(hit) refresh();
    }).observe(box, { childList:true, subtree:true });
  }

  /* clear the stale flag left behind by the old reloading version */
  try{ sessionStorage.removeItem('gob_reopen_cart'); }catch(e){}

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ watch(); refresh(); });
  } else { watch(); refresh(); }
})();

/* ---------- block 10 (was inline #10) ---------- */
(function(){
  /* ══════════ TUNE ══════════ */

  /* How often the watchdog checks that the page is not stuck locked. */
  var WATCH_MS = 400;

  /* ══════════════════════════ */

  /* scroll-lock classes that themes and apps commonly leave behind */
  var LOCKS = ['gob-cart-lock','js-drawer-open','js-drawer-open-nav',
               'drawer-open','cart-open','no-scroll','overflow-hidden','modal-open'];

  /* anything here being on screen is a legitimate reason for the page to be
     locked — the mobile menu, a popup, the cart itself. If NONE of these are
     present, a locked page is a bug and we clear it. */
  var OPEN_MARKERS = [
    '#HeaderCart.is-active',
    '.drawer.is-active',
    '.drawer--is-open',
    '#NavDrawer.is-active',
    '.site-nav--open',
    '.modal.is-active',
    '.modal--is-active',
    '[data-drawer].is-active',
    '.popup-cta.is-active'
  ];

  function drawer(){ return document.querySelector('#HeaderCart'); }
  function isOpen(){
    var d = drawer();
    return !!(d && d.classList.contains('is-active'));
  }

  /* V152: one DOM walk for all markers instead of nine. Profiled on the live
     product page (phone, 4x CPU): anyOpen() alone cost ~570 ms, because the
     html/body observer and every wheel/touch event called it first. */
  var OPEN_SEL = OPEN_MARKERS.join(',');
  function anyOpen(){
    try{ return !!document.querySelector(OPEN_SEL); }catch(e){}
    for(var i = 0; i < OPEN_MARKERS.length; i++){
      try{ if(document.querySelector(OPEN_MARKERS[i])) return true; }catch(e){}
    }
    return false;
  }

  /* cheap test — no getComputedStyle, safe to call on every touch */
  function looksLocked(){
    var h = document.documentElement, b = document.body;
    if(h.style.overflow === 'hidden' || b.style.overflow === 'hidden') return true;
    if(b.style.position === 'fixed') return true;
    for(var i = 0; i < LOCKS.length; i++){
      if(h.classList.contains(LOCKS[i]) || b.classList.contains(LOCKS[i])) return true;
    }
    return false;
  }

  /* remove every lock we can find, and put the scroll position back if the
     page was frozen with the position:fixed trick */
  function unlock(){
    var h = document.documentElement, b = document.body;

    var top = b.style.top;
    var restore = (b.style.position === 'fixed' && top) ? parseInt(top, 10) : null;

    LOCKS.forEach(function(c){ h.classList.remove(c); b.classList.remove(c); });

    ['overflow','overflow-y','position','top','left','right','width','height','padding-right']
      .forEach(function(p){ h.style.removeProperty(p); b.style.removeProperty(p); });

    if(restore !== null){ window.scrollTo(0, Math.abs(restore)); }

    /* a stranded overlay blocks scrolling even when it is invisible */
    var ov = document.getElementById('gob-cart-overlay');
    if(ov && !isOpen()) ov.classList.remove('is-open');
  }

  function closeCart(){
    var d = drawer();
    if(d) d.classList.remove('is-active');

    var ov = document.getElementById('gob-cart-overlay');
    if(ov) ov.classList.remove('is-open');

    unlock();

    /* tell the theme too, so its own state follows along */
    ['cart:close','CartDrawer:close'].forEach(function(ev){
      try{ document.dispatchEvent(new CustomEvent(ev, { detail:{}, bubbles:true })); }catch(e){}
    });

    /* the theme sometimes re-applies its lock a beat later — catch that */
    [60, 200, 500, 900].forEach(function(ms){
      setTimeout(function(){ if(!anyOpen()) unlock(); }, ms);
    });
  }

  /* exposed so you can type gobCloseCart() in the console to test */
  window.gobCloseCart = closeCart;

  /* ── the close button and the dark overlay always work ──
     Capture phase, so nothing the theme does can swallow the tap. */
  function onTap(e){
    var t = e.target;
    if(!t || !t.closest) return;
    if(t.closest('.gob-drawer-close') || t.closest('#gob-cart-overlay')){
      closeCart();
    }
  }
  document.addEventListener('click', onTap, true);
  document.addEventListener('touchend', onTap, true);

  /* ── Escape closes it on desktop ── */
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' || e.keyCode === 27){ if(isOpen()) closeCart(); }
  });

  /* ── THE IMPORTANT ONE ──
     The moment the customer tries to scroll, if nothing is legitimately open
     and the page is locked, the lock dies. This catches every stuck state,
     including ones caused by the theme or an app, without us having to know
     which class did it. */
  function rescue(){
    if(!looksLocked()) return;   /* V152: cheap check first */
    if(anyOpen()) return;
    unlock();
  }
  ['touchstart','wheel','mousedown','keydown'].forEach(function(ev){
    document.addEventListener(ev, rescue, { passive:true, capture:true });
  });

  /* ── watchdog: never leave the page unscrollable ── */
  /* V152: the 400 ms watchdog interval is gone — the observer below reacts the
     instant a lock class or style changes, and the input listeners above
     rescue a stuck page on the very next touch, wheel, click or key. */

  /* also react the instant a lock class is added or removed */
  try{
    var mo = new MutationObserver(function(){ if(looksLocked() && !anyOpen()) unlock(); });   /* V152: cheap check first */
    mo.observe(document.documentElement, { attributes:true, attributeFilter:['class','style'] });
    mo.observe(document.body,            { attributes:true, attributeFilter:['class','style'] });
  }catch(e){}

  /* returning via the back/forward cache, or coming back to the tab */
  window.addEventListener('pageshow', function(){ if(!anyOpen()) unlock(); });
  document.addEventListener('visibilitychange', function(){
    if(!document.hidden && looksLocked() && !anyOpen()) unlock();
  });

  if(looksLocked() && !anyOpen()) unlock();
})();

/* ---------- block 11 (was inline #11) ---------- */
(function(){
  /* ══════════ TUNE ══════════ */

  /* The short wording. The percent is added automatically.
     Result: "GOB Club –30%" */
  var LABEL = 'GOB Club';

  /* Character used before the number. '–' is an en dash, not a hyphen. */
  var DASH = '–';

  /* If a discount has no percent in its name, show the money saved instead.
     Result: "GOB Club –€34,19". Set to false to show just "GOB Club". */
  var SHOW_AMOUNT_FALLBACK = true;

  /* ══════════════════════════ */

  /* only rewrite lines that are actually discounts */
  var IS_DISCOUNT = /discount|gob\s*club|member/i;

  function short(text){
    var pct = text.match(/(\d{1,3})\s*%/);
    if(pct) return LABEL + ' ' + DASH + pct[1] + '%';

    if(SHOW_AMOUNT_FALLBACK){
      var amt = text.match(/[-−–]?\s*([€$£]\s?[\d.,]+)/);
      if(amt) return LABEL + ' ' + DASH + amt[1].replace(/\s/g, '');
    }
    return LABEL;
  }

  function targets(){
    var out = [];
    var box = document.querySelector('#HeaderCart') || document;

    /* the standard Shopify discount markup */
    box.querySelectorAll('.order-discount__item, .order-discount, [class*="discount"]').forEach(function(el){
      out.push(el);
    });

    return out;
  }

  var writing = false;

  function fix(){
    if(writing) return;
    writing = true;

    try{
      targets().forEach(function(el){
        /* never touch our own offer cards or a wrapper full of other things */
        if(el.closest && el.closest('.gob-np')) return;
        if(el.querySelector && el.querySelector('button, a, img, input')) return;

        var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if(!txt || txt.length > 90) return;
        if(!IS_DISCOUNT.test(txt)) return;

        var want = short(txt);
        if(txt === want) return;              /* already correct — no write, no loop */

        el.textContent = want;
        el.classList.add('gob-dl');
      });
    }catch(e){}

    writing = false;
  }

  /* ── run in the same frame the theme redraws in ──
     A MutationObserver callback fires before the browser paints, so doing the
     rewrite here — with no setTimeout — means the long label never appears. */
  function watch(){
    var box = document.querySelector('#HeaderCart');
    if(!box) return false;
    new MutationObserver(function(){ fix(); }).observe(box, {
      childList:true, subtree:true   /* V152: no characterData — the countdown changed it every second */
    });
    return true;
  }

  ['cart:updated','cart:build','cart:refresh','ajaxProduct:added','cart:open','CartDrawer:open'].forEach(function(ev){
    document.addEventListener(ev, function(){ fix(); setTimeout(fix, 120); });
  });

  function start(){
    if(!watch()){ setTimeout(start, 300); return; }   /* drawer not in the DOM yet */
    fix();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();

/* ---------- block 12 (was inline #12) ---------- */
/* ══════════ GOB — ADD-ON TOGGLE SYNC ══════════ */
/* THE BUG, exactly:
   In the theme, both toggles render as CHECKED whenever the cart attribute
   is blank — i.e. for every new visitor:

     {% if cart.attributes.xw-switch =='true' or cart.attributes.xw-switch == blank %}checked{% endif %}

   But the actual product is only ever put in the cart inside the
   checkbox's 'change' handler. No click, no change event, no line item.
   So the customer sees two green toggles and pays for neither — or, as in
   your screenshot, for only one of them.

   This block makes the cart and the toggles agree, always: on load, on every
   cart change, and one last time the moment Check out is pressed.

   Paste at the very bottom of header-cart-drawer.liquid, after the
   discount label lock. */

(function(){
  /* ══════════ TUNE ══════════ */

  /* true  = the toggles stay pre-ticked, and the block ADDS the missing
             products so the cart matches what the customer sees.
     false = the toggles start OFF for new visitors and nothing is charged
             until the customer switches one on themselves.

     Read the note I sent with this file before choosing. */
  var DEFAULT_ON = true;

  /* Also fix things up when Check out is pressed. Leave this on — it is the
     last line of defence before money changes hands. */
  var GUARD_CHECKOUT = true;

  /* Hard ceiling on how long Check out may be delayed, in ms.
     Whatever happens, the customer goes through after this. */
  var MAX_WAIT = 1500;

  /* ══════════════════════════ */

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var BASE = ROOT.replace(/\/$/, '');

  var ADDONS = [
    { id:'wf_switch_btn', attr:'wf-switch', match:/shipping\s*insurance/i },
    { id:'xw_switch_btn', attr:'xw-switch', match:/extended\s*warranty/i  }
  ];

  function box(a){ return document.getElementById(a.id); }
  function hidden(a){ return document.querySelector('input[name="attributes[' + a.attr + ']"]'); }

  function getCart(){
    return fetch(BASE + '/cart.js', { headers:{ 'Accept':'application/json' }, credentials:'same-origin' })
      .then(function(r){ return r.json(); })
      .catch(function(){ return null; });
  }

  function inCart(cart, a){
    if(!cart || !cart.items) return false;
    for(var i = 0; i < cart.items.length; i++){
      if(a.match.test(cart.items[i].title || '')) return true;
    }
    return false;
  }

  /* has this cart ever had a real product in it? no products, no add-ons */
  function hasProduct(cart){
    if(!cart || !cart.items) return false;
    for(var i = 0; i < cart.items.length; i++){
      var t = cart.items[i].title || '';
      var isAddon = false;
      ADDONS.forEach(function(a){ if(a.match.test(t)) isAddon = true; });
      if(/gob club membership/i.test(t)) isAddon = true;
      if(!isAddon) return true;
    }
    return false;
  }

  /* Drive the theme's OWN handler rather than reimplementing it. Setting the
     checkbox and firing a real change event makes the theme swap the icon,
     add or remove the line item, and save the cart attribute — all the things
     it already knows how to do correctly. */
  function set(a, want){
    var cb = box(a);
    if(!cb) return false;
    if(cb.checked === want && !FORCE) return false;

    var h = hidden(a);
    if(h) h.value = want ? 'true' : 'false';
    cb.checked = want;
    try{ cb.dispatchEvent(new Event('change', { bubbles:true })); }catch(e){ return false; }
    return true;
  }

  var FORCE = false;

  /* fire the theme's handler even though the checkbox is already in the right
     visual state — this is what actually creates the missing line item */
  function force(a, want){
    FORCE = true;
    var out = set(a, want);
    FORCE = false;
    return out;
  }

  var working = false;

  function reconcile(){
    /* V152: one queue for the add-ons — see gob-smooth.js */
    if(window.GOBSmooth && GOBSmooth.syncAddons) return GOBSmooth.syncAddons().then(function(){ return false; }, function(){ return false; });
    if(working) return Promise.resolve(false);
    working = true;

    return getCart().then(function(cart){
      working = false;
      if(!cart) return false;

      var products = hasProduct(cart);
      var changed = false;

      ADDONS.forEach(function(a){
        var cb = box(a);
        if(!cb) return;

        var have = inCart(cart, a);

        /* an empty cart must never carry a paid add-on to checkout */
        if(!products){
          if(have) changed = force(a, false) || changed;
          return;
        }

        if(DEFAULT_ON){
          /* the toggle is the truth — make the cart match it */
          if(cb.checked && !have)  changed = force(a, true)  || changed;
          if(!cb.checked && have)  changed = force(a, false) || changed;
        } else {
          /* the cart is the truth — make the toggle match it, and start off */
          var h = hidden(a);
          var everSet = h && (h.value === 'true' || h.value === 'false') && h.getAttribute('data-gob-seen');
          if(!everSet && !have){
            if(h) h.setAttribute('data-gob-seen', '1');
            changed = force(a, false) || changed;
          } else if(cb.checked !== have){
            changed = force(a, have) || changed;
          }
        }
      });

      return changed;
    }).catch(function(){ working = false; return false; });
  }

  /* is anything currently out of step? cheap, no writes */
  function mismatch(){
    return getCart().then(function(cart){
      if(!cart) return false;
      var products = hasProduct(cart);
      var bad = false;
      ADDONS.forEach(function(a){
        var cb = box(a);
        if(!cb) return;
        var have = inCart(cart, a);
        if(!products && have){ bad = true; return; }
        if(products && cb.checked !== have) bad = true;
      });
      return bad;
    }).catch(function(){ return false; });
  }

  /* ── last line of defence: the Check out button ── */
  var passing = false;

  function guard(){
    if(!GUARD_CHECKOUT) return;

    document.addEventListener('click', function(e){
      if(passing) return;

      var t = e.target;
      if(!t || !t.closest) return;

      var btn = t.closest('[name="checkout"], .cart__checkout, button[type="submit"][name="checkout"]');
      if(!btn) return;
      if(!btn.closest('#HeaderCart')) return;

      /* hold the click only long enough to put the cart right */
      e.preventDefault();
      e.stopPropagation();

      var released = false;
      function go(){
        if(released) return;
        released = true;
        passing = true;
        try{ btn.click(); }catch(err){
          var f = btn.closest('form');
          if(f) f.submit();
        }
        setTimeout(function(){ passing = false; }, 2000);
      }

      setTimeout(go, MAX_WAIT);            /* never trap the customer */

      mismatch().then(function(bad){
        if(!bad){ go(); return; }
        reconcile().then(function(){ setTimeout(go, 350); });
      });
    }, true);
  }

  /* ── run it ── */
  var t = null;
  function nudge(){
    clearTimeout(t);
    t = setTimeout(reconcile, 250);
  }

  ['cart:updated','cart:build','cart:refresh','ajaxProduct:added','cart:open','CartDrawer:open']
    .forEach(function(ev){ document.addEventListener(ev, nudge); });

  function start(){
    guard();
    setTimeout(reconcile, 600);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();

/* ---------- block 13 (was inline #13) ---------- */
/* ══════════ GOB — AJAX REMOVE (NO PAGE JUMP) ══════════ */
/* The remove control on some rows — GOB Club Membership especially — is a
   plain link to /cart/change. A plain link NAVIGATES. That is why you get
   thrown out of the drawer and onto the cart page.

   This intercepts every remove inside the drawer, removes the line over
   AJAX instead, and redraws the drawer in place. Nothing navigates,
   nothing reloads, the drawer stays open.

   Paste at the very bottom of header-cart-drawer.liquid, after the
   add-on toggle sync. */

(function(){
  /* ══════════ TUNE ══════════ */

  /* Fade the row out before it disappears. 0 = instant. */
  var FADE_MS = 160;

  /* ══════════════════════════ */

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var BASE = ROOT.replace(/\/$/, '');

  function getCart(){
    return fetch(BASE + '/cart.js', { headers:{ 'Accept':'application/json' }, credentials:'same-origin' })
      .then(function(r){ return r.json(); })
      .catch(function(){ return null; });
  }

  /* Archetype rebuilds the drawer from the cart OBJECT in the event detail.
     Passing an empty detail makes the theme bail silently. */
  function redraw(cart){
    var detail = cart ? { cart:cart } : {};
    ['cart:updated','cart:build','cart:refresh'].forEach(function(ev){
      try{ document.dispatchEvent(new CustomEvent(ev, { detail:detail, bubbles:true })); }catch(e){}
    });
    if(cart && window.theme){
      var t = window.theme;
      [ t.cart, t.CartDrawer, t.cartDrawer, t.Cart ].forEach(function(o){
        if(!o) return;
        ['buildCart','updateCart','renderCart','build','refresh'].forEach(function(fn){
          if(typeof o[fn] === 'function'){ try{ o[fn](cart); }catch(e){} }
        });
      });
    }
    if(cart && !window.GOBSmooth){   /* V152: the drawer paint rolls the subtotal */
      document.querySelectorAll('#HeaderCart [data-subtotal]').forEach(function(el){
        try{ el.textContent = money(cart.total_price); }catch(e){}
      });
    }
  }

  var MONEY_FORMAT = '';
  function money(cents){
    var f = MONEY_FORMAT ||
            (window.theme && theme.moneyFormat) ||
            (window.Shopify && Shopify.money_format) || '€{{amount_with_comma_separator}}';
    var v = (cents / 100);
    var s = f.indexOf('comma_separator') > -1
      ? v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      : v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[^}]*\}\}/, s);
  }

  /* Pull the line number or the variant/key out of whatever the control is.
     Covers data-attributes and the plain /cart/change?line=N&quantity=0 link. */
  function target(el){
    var line = el.getAttribute('data-line') ||
               el.getAttribute('data-cart-item-index') ||
               (el.closest('[data-line]') && el.closest('[data-line]').getAttribute('data-line'));
    if(line) return { line:parseInt(line, 10) };

    var key = el.getAttribute('data-key') ||
              el.getAttribute('data-cart-item-key') ||
              (el.closest('[data-key]') && el.closest('[data-key]').getAttribute('data-key')) ||
              (el.closest('[data-cart-item-key]') && el.closest('[data-cart-item-key]').getAttribute('data-cart-item-key'));
    if(key) return { id:key };

    var href = el.getAttribute('href') || '';
    if(href.indexOf('/cart/change') > -1){
      var l = href.match(/[?&]line=(\d+)/);
      if(l) return { line:parseInt(l[1], 10) };
      var i = href.match(/[?&]id=([^&]+)/);
      if(i) return { id:decodeURIComponent(i[1]) };
    }
    return null;
  }

  function isRemove(el){
    if(!el) return false;
    if(el.matches('[data-cart-remove], .cart__remove, .ajaxcart__qty-remove, [data-remove], .gob-remove')) return true;
    var href = el.getAttribute && el.getAttribute('href');
    if(href && href.indexOf('/cart/change') > -1 && /quantity=0|&q=0/.test(href)) return true;
    /* a quantity control already at 1 that steps down to 0 */
    if(el.matches('[data-qty-minus], .js-qty__adjust--minus')){
      var inp = el.parentNode && el.parentNode.querySelector('input');
      if(inp && parseInt(inp.value, 10) === 1) return true;
    }
    return false;
  }

  var busy = false;

  document.addEventListener('click', function(e){
    if(busy) return;
    var t = e.target;
    if(!t || !t.closest) return;

    var el = t.closest('a, button, [role="button"], [data-cart-remove], [data-remove]');
    if(!el) return;
    if(!el.closest('#HeaderCart')) return;
    if(!isRemove(el)) return;

    var tgt = target(el);
    if(!tgt) return;                 /* can't identify it — let the theme have it */

    e.preventDefault();
    e.stopPropagation();

    busy = true;

    var row = el.closest('[data-line], .ajaxcart__product, .cart__item, li, tr');
    if(row && FADE_MS){
      row.style.transition = 'opacity ' + FADE_MS + 'ms ease';
      row.style.opacity = '0.35';
    }

    var body = { quantity:0 };
    if(tgt.line) body.line = tgt.line; else body.id = tgt.id;

    /* V152: removing the last kit takes Shipping Insurance + Extended Warranty
       with it in the same request — one write, one paint, the subtotal rolls
       straight to zero instead of stopping at the add-ons' 5,98. */
    var gsU = (window.GOBSmooth && GOBSmooth.extrasFor && tgt.id) ? GOBSmooth.extrasFor(tgt.id) : null;
    var plain = JSON.stringify(body);
    if(gsU) body = { updates: gsU };

    fetch(BASE + (gsU ? '/cart/update.js' : '/cart/change.js'), {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      credentials:'same-origin',
      body: JSON.stringify(body)
    })
    .then(function(r){
      /* V152: if the one-request removal is refused, fall back to the plain one */
      if(!r.ok && gsU) return fetch(BASE + '/cart/change.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, credentials:'same-origin', body: plain }).then(function(r2){ return r2.json(); });
      return r.json();
    })
    .then(function(cart){
      redraw(cart);   /* V152: one redraw; the add-on queue re-checks on paint */
    })
    .catch(function(){
      if(row) row.style.opacity = '';
    })
    .then(function(){
      setTimeout(function(){ busy = false; }, 300);
    });
  }, true);
})();


/* ══════════════════════════════════════════════════════════════════════════
   GOB — ADD-ON ROW VISIBILITY LOCK  (2026-09-03)

   THE BUG THIS FIXES
   ------------------
   header-cart-drawer.liquid ships both add-on rows hidden by CSS:

       #worry_free, #extended_warranty { display: none; }

   and relies on Liquid stamping an inline style to reveal them:

       <div id="worry_free" {% if cart.item_count > 0 %}style="display: flex"{% endif %}>

   So a page rendered while the cart is EMPTY — every first load in incognito,
   and every load after the shopper clears the cart — paints both rows with no
   inline style, i.e. invisible.

   The only code that ever puts the inline style back lives in theme.js, inside
   the ONE branch that adds the add-on product to the cart:

       ...? item ? (item.quantity > 1 && reduce())            <-- never sets display
             : (add(), container.style.display = "flex")      <-- sets display
       : item && remove()                                     <-- never sets display

   If the add-on is already in the cart, or is being removed, the row is left
   hidden. theme.updateShippingInsurance() and theme.updateExtendedWarranty()
   are fired back to back without awaiting each other and both POST to
   /cart/add.js, which Shopify serialises per session — so which of the two
   lands in the "already in cart" branch varies run to run. That is why the
   rows flicker, and why it is sometimes one row and sometimes both.

   WHAT THIS BLOCK DOES
   --------------------
   Makes the rows' visibility a pure function of the cart, re-evaluated after
   every cart change: visible when the cart holds a real product, hidden when
   it does not. Exactly the rule the Liquid intends — just no longer dependent
   on which branch of theme.js happened to run.

   It sets display only. It never adds, removes or changes a cart item, never
   touches the checkboxes, and never fires a change event, so it cannot alter
   what the shopper is charged. Purely cosmetic, and idempotent.
   ══════════════════════════════════════════════════════════════════════════ */
(function(){
  var ROWS   = ['worry_free', 'extended_warranty'];
  /* titles that are add-ons, not real products — same set theme.js uses */
  var ADDON  = /shipping\s*insurance|extended\s*warranty|gob club membership/i;
  var ROOT   = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var BASE   = ROOT.replace(/\/$/, '');
  var timer  = null, busy = false;

  function hasRealProduct(cart){
    if(!cart || !cart.items) return false;
    for(var i = 0; i < cart.items.length; i++){
      if(!ADDON.test(cart.items[i].title || '')) return true;
    }
    return false;
  }

  function paint(show){
    ROWS.forEach(function(id){
      var el = document.getElementById(id);
      if(!el) return;
      var want = show ? 'flex' : 'none';
      if(el.style.display !== want) el.style.display = want;
    });
  }

  function sync(){
    if(busy) return;
    busy = true;
    fetch(BASE + '/cart.js', { headers:{ 'Accept':'application/json' }, credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){ if(cart) paint(hasRealProduct(cart)); })
      .catch(function(){ /* leave the rows exactly as they are */ })
      .then(function(){ busy = false; });
  }

  function schedule(){ clearTimeout(timer); timer = setTimeout(sync, 200); }

  function boot(){
    sync();
    ['cart:updated','cart:build','ajaxProduct:added','CartDrawer:open']
      .forEach(function(ev){ document.addEventListener(ev, schedule); });
    /* the drawer can also be opened without firing a cart event */
    document.addEventListener('click', function(e){
      if(e.target && e.target.closest && e.target.closest('[href="#HeaderCart"], .site-header__cart, [data-cart-toggle]')) schedule();
    }, true);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ═══ GOB CLUB MEMBER CARD ROW — one-time entrance (V97, 2026-09-30) ═══════════════
   snippets/cart-item.liquid renders the GOB Club Membership line as a dark Club card
   (.cart__item.gob-mt). The drawer rebuilds its
   rows on every cart change, so a CSS animation alone would replay on every
   quantity click. This marks the row .is-new only the first time a given
   membership line is seen while the drawer is open; the key is kept in
   sessionStorage and cleared when the membership leaves the cart, so Remove →
   Apply plays it again.
   ═════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  var KEY = 'gob_mt_seen', t = null;
  function get(){ try{ return sessionStorage.getItem(KEY) || ''; }catch(e){ return ''; } }
  function set(v){ try{ sessionStorage.setItem(KEY, v); }catch(e){} }
  function check(){
    var drawer = document.getElementById('HeaderCart');
    if(!drawer) return;
    var row = drawer.querySelector('.cart__item.gob-mt');
    if(!row){ if(drawer.querySelector('.cart__items')) set(''); return; }
    if(!drawer.classList.contains('is-active')) return;
    var k = row.getAttribute('data-key') || '1';
    if(get() === k) return;
    set(k);
    row.classList.add('is-new');
  }
  function soon(){ clearTimeout(t); t = setTimeout(check, 40); }
  ['cart:updated','ajaxProduct:added','cart:open','CartDrawer:open'].forEach(function(ev){ document.addEventListener(ev, soon); });
  function watch(){
    var d = document.getElementById('HeaderCart');
    if(!d) return;
    new MutationObserver(soon).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', watch) : watch();
})();

/* ═══ GOB CLUB CARD — giveaway time left (V97, 2026-09-30) ═══════════════════
   Fills [data-gob-giveaway-left] on the membership card (snippets/cart-item.liquid)
   with the time until this month's giveaway closes: the last day of the month,
   23:59:59 Europe/Vilnius (the official rules' close). "3d 16h" when a day or
   more is left, "16h 43m" on the last day. After the close the Vilnius month
   has already rolled over, so it counts to next month's close by itself.
   Re-runs every 30 s and whenever the drawer rebuilds its rows.
   ═════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  var TZ = 'Europe/Vilnius';
  function parts(d){
    var o = {};
    new Intl.DateTimeFormat('en-US', { timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
      .formatToParts(d).forEach(function(p){ o[p.type] = +p.value; });
    return o;
  }
  function tzOffsetMs(d){
    var p = parts(d);
    return Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second) - Math.floor(d.getTime() / 1000) * 1000;
  }
  function closeMs(now){
    var p = parts(now);
    var last = new Date(Date.UTC(p.year, p.month, 0)).getUTCDate();
    var wall = Date.UTC(p.year, p.month - 1, last, 23, 59, 59);
    return wall - tzOffsetMs(new Date(wall));
  }
  function fmt(ms){
    var m = Math.max(0, Math.floor(ms / 60000)), d = Math.floor(m / 1440), h = Math.floor(m / 60) % 24, mi = m % 60;
    return d ? d + 'd ' + h + 'h' : h + 'h ' + (mi < 10 ? '0' : '') + mi + 'm';
  }
  function paint(){
    var els = document.querySelectorAll('[data-gob-giveaway-left]');
    if(!els.length) return;
    var now = new Date(), txt;
    try{ txt = fmt(closeMs(now) - now.getTime()); }catch(e){ return; }
    for(var i = 0; i < els.length; i++){ if(els[i].textContent !== txt) els[i].textContent = txt; }
  }
  var t = null;
  function soon(){ clearTimeout(t); t = setTimeout(paint, 30); }
  ['cart:updated','ajaxProduct:added','cart:open','CartDrawer:open'].forEach(function(ev){ document.addEventListener(ev, soon); });
  function watch(){
    var d = document.getElementById('HeaderCart');
    if(d) new MutationObserver(soon).observe(d, { childList: true, subtree: true });
    paint();
    setInterval(paint, 30000);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', watch) : watch();
})();
